const types = [
  { key: 'all', name: '所有', isShow: false },
  { key: 'deptInvolved', name: '部门参与', isShow: false },
  { key: 'deptManage', name: '部门管理', isShow: false },
  { key: 'myApplication', name: '我的申请', isShow: true },
  { key: 'myTodo', name: '我的待办', isShow: true }
]

const targets = [
  { key: 'allProc', name: '申请次数' },
  { key: 'successPass', name: '通过' },
  { key: 'failedPass', name: '不通过' },
  { key: 'termination', name: '终止' },
  { key: 'toDo', name: '待办' },
  { key: 'keepRate', name: '积压率' },
  { key: 'avgDuration', name: '平均办结' }
]

const tasks = [
  { key: 'allTask', name: '所有' },
  { key: 'done', name: '已办' },
  { key: 'termination', name: '终止' },
  { key: 'keepRateDouble', name: '积压率' },
  { key: 'avgDuration', name: '平均办结' }
]

export {
  types,
  targets,
  tasks
}
